import { apiAuth, apiResponseType } from ".";

export const getRevenueTypesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`revenue-types?page=${page}`);

export const selectRevenueTypesData = (): apiResponseType =>
  apiAuth.get(`revenue-types/select`);

export const searchRevenueTypesData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`revenue-types?name=${params.name}`);

export const toggleRevenueTypeStatus = (uuid: string) =>
  apiAuth.put(`revenue-types/${uuid}/toggle-status`) as apiResponseType;

export const storeRevenueTypeData = (data: {
  name: string;
  description?: string;
}) => apiAuth.post("revenue-types/store", data) as apiResponseType;

export const updateRevenueTypeData = (
  uuid: string,
  data: {
    name: string;
    description?: string;
  }
) => apiAuth.put(`revenue-types/${uuid}/update`, data) as apiResponseType;

export const deleteRevenueTypeData = (uuid: string) =>
  apiAuth.delete(`revenue-types/${uuid}/destroy`) as apiResponseType;

export const getShowRevenueType = (uuid: string) =>
  apiAuth.get(`revenue-types/${uuid}/show`) as apiResponseType;
